export default __webpack_public_path__ + "static/32932-fecdc3c4bdc6d09a23e3aa8cb73af444.jpg";